import uuid from 'uuid-random';
import { getMessageFromCode } from 'eth-rpc-errors';
import axios from 'axios';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function assetToString(asset) {
  if (!!asset.address) return asset.blockchain + "." + asset.symbol + "--" + asset.address;else return asset.blockchain + "." + asset.symbol;
}

var isEvmBlockchain = function isEvmBlockchain(blockchainMeta) {
  return blockchainMeta.type === 'EVM';
};
var isCosmosBlockchain = function isCosmosBlockchain(blockchainMeta) {
  return blockchainMeta.type === 'COSMOS';
};
var isSolanaBlockchain = function isSolanaBlockchain(blockchainMeta) {
  return blockchainMeta.type === 'SOLANA';
};
var isTronBlockchain = function isTronBlockchain(blockchainMeta) {
  return blockchainMeta.type === 'TRON';
};
var isTransferBlockchain = function isTransferBlockchain(blockchainMeta) {
  return blockchainMeta.type === 'TRANSFER';
};
var isStarknetBlockchain = function isStarknetBlockchain(blockchainMeta) {
  return blockchainMeta.type === 'STARKNET';
};
var isTonBlockchain = function isTonBlockchain(blockchainMeta) {
  return blockchainMeta.type === 'TON';
};
var evmBlockchains = function evmBlockchains(blockchains) {
  return blockchains.filter(isEvmBlockchain);
};
var solanaBlockchain = function solanaBlockchain(blockchains) {
  return blockchains.filter(isSolanaBlockchain);
};
var starknetBlockchain = function starknetBlockchain(blockchains) {
  return blockchains.filter(isStarknetBlockchain);
};
var tronBlockchain = function tronBlockchain(blockchains) {
  return blockchains.filter(isTronBlockchain);
};
var cosmosBlockchains = function cosmosBlockchains(blockchains) {
  return blockchains.filter(isCosmosBlockchain);
};
var transferBlockchains = function transferBlockchains(blockchains) {
  return blockchains.filter(isTransferBlockchain);
};
var tonBlockchain = function tonBlockchain(blockchains) {
  return blockchains.filter(isTonBlockchain);
};

/**
 * Routing Result Type
 *
 */
var RoutingResultType;
(function (RoutingResultType) {
  RoutingResultType["OK"] = "OK";
  RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
  RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
  RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})(RoutingResultType || (RoutingResultType = {}));

/**
 * The type of transaction
 */
var TransactionType;
(function (TransactionType) {
  TransactionType["EVM"] = "EVM";
  TransactionType["TRANSFER"] = "TRANSFER";
  TransactionType["COSMOS"] = "COSMOS";
  TransactionType["SOLANA"] = "SOLANA";
  TransactionType["TRON"] = "TRON";
  TransactionType["STARKNET"] = "STARKNET";
  TransactionType["TON"] = "TON";
})(TransactionType || (TransactionType = {}));
/**
 * The type of transaction
 * @deprecated use TransactionType instead
 */
var GenericTransactionType;
(function (GenericTransactionType) {
  GenericTransactionType["EVM"] = "EVM";
  GenericTransactionType["TRANSFER"] = "TRANSFER";
  GenericTransactionType["COSMOS"] = "COSMOS";
  GenericTransactionType["SOLANA"] = "SOLANA";
})(GenericTransactionType || (GenericTransactionType = {}));
/**
 * The status of transaction in tracking
 */
var TransactionStatus;
(function (TransactionStatus) {
  TransactionStatus["FAILED"] = "failed";
  TransactionStatus["RUNNING"] = "running";
  TransactionStatus["SUCCESS"] = "success";
})(TransactionStatus || (TransactionStatus = {}));

var isCosmosTransaction = function isCosmosTransaction(transaction) {
  return transaction.type === TransactionType.COSMOS;
};

var isSolanaTransaction = function isSolanaTransaction(transaction) {
  return transaction.type === TransactionType.SOLANA;
};

var isTransferTransaction = function isTransferTransaction(transaction) {
  return transaction.type === TransactionType.TRANSFER;
};

var TonChainID;
(function (TonChainID) {
  TonChainID["MAINNET"] = "-239";
  TonChainID["TESTNET"] = "-3";
})(TonChainID || (TonChainID = {}));

var isEvmTransaction = function isEvmTransaction(transaction) {
  return transaction.type === TransactionType.EVM;
};

var MetamaskErrorCodes = {
  rpc: {
    invalidInput: -32000,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

function prepareEvmTransaction(evmTx, isApprove) {
  var gasPrice = !!evmTx.gasPrice && !evmTx.gasPrice.startsWith('0x') ? '0x' + parseInt(evmTx.gasPrice).toString(16) : null;
  var manipulatedTx = _extends({}, evmTx, {
    gasPrice: gasPrice
  });
  var tx = {};
  if (!!manipulatedTx.from) tx = _extends({}, tx, {
    from: manipulatedTx.from
  });
  if (isApprove) {
    if (!!manipulatedTx.approveTo) tx = _extends({}, tx, {
      to: manipulatedTx.approveTo
    });
    if (!!manipulatedTx.approveData) tx = _extends({}, tx, {
      data: manipulatedTx.approveData
    });
  } else {
    if (!!manipulatedTx.txTo) tx = _extends({}, tx, {
      to: manipulatedTx.txTo
    });
    if (!!manipulatedTx.txData) tx = _extends({}, tx, {
      data: manipulatedTx.txData
    });
    if (!!manipulatedTx.value) tx = _extends({}, tx, {
      value: manipulatedTx.value
    });
    if (!!manipulatedTx.gasLimit) tx = _extends({}, tx, {
      gasLimit: manipulatedTx.gasLimit
    });
    if (!!manipulatedTx.gasPrice) tx = _extends({}, tx, {
      gasPrice: manipulatedTx.gasPrice
    });
  }
  return tx;
}
function checkApprovalSync(_x, _x2, _x3) {
  return _checkApprovalSync.apply(this, arguments);
}
function _checkApprovalSync() {
  _checkApprovalSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestId, txId, rangoClient) {
    var approvalResponse;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 1;
          _context3.next = 4;
          return rangoClient.isApproved(requestId, txId);
        case 4:
          approvalResponse = _context3.sent;
          if (!(approvalResponse != null && approvalResponse.isApproved)) {
            _context3.next = 7;
            break;
          }
          return _context3.abrupt("return", true);
        case 7:
          if (!(!(approvalResponse != null && approvalResponse.isApproved) && (approvalResponse == null ? void 0 : approvalResponse.txStatus) === TransactionStatus.FAILED)) {
            _context3.next = 9;
            break;
          }
          return _context3.abrupt("return", false);
        case 9:
          _context3.next = 14;
          break;
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](1);
          console.log('ignorinig error', {
            err: _context3.t0
          });
        case 14:
          _context3.next = 16;
          return sleep(3000);
        case 16:
          _context3.next = 0;
          break;
        case 18:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 11]]);
  }));
  return _checkApprovalSync.apply(this, arguments);
}
var checkTransactionStatusSync = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(requestId, txId, rangoClient) {
    var txStatus;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 1;
          _context.next = 4;
          return rangoClient.status({
            requestId: requestId,
            txId: txId
          });
        case 4:
          txStatus = _context.sent;
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
          console.log('ignorinig error', {
            err: _context.t0
          });
        case 10:
          if (!txStatus) {
            _context.next = 13;
            break;
          }
          if (!(!!txStatus.status && [TransactionStatus.FAILED, TransactionStatus.SUCCESS].includes(txStatus.status))) {
            _context.next = 13;
            break;
          }
          return _context.abrupt("return", txStatus);
        case 13:
          _context.next = 15;
          return sleep(3000);
        case 15:
          _context.next = 0;
          break;
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 7]]);
  }));
  return function checkTransactionStatusSync(_x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();
var executeEvmRoute = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(client, signer, route) {
    var tx, requestId, error, resultType, evmTransaction, txChainId, signerChainId, approveTxData, approveTx, isApproved, mainTxData, mainTx, status;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          tx = route.tx, requestId = route.requestId, error = route.error, resultType = route.resultType;
          if (!(resultType != 'OK')) {
            _context2.next = 3;
            break;
          }
          throw new Error(resultType);
        case 3:
          if (!(!!error || !tx)) {
            _context2.next = 5;
            break;
          }
          throw new Error(error || 'Error creating the transaction.');
        case 5:
          if (!((tx == null ? void 0 : tx.type) !== TransactionType.EVM)) {
            _context2.next = 7;
            break;
          }
          throw new Error('Non Evm transactions are not supported yet.');
        case 7:
          evmTransaction = tx;
          if (evmTransaction) {
            _context2.next = 10;
            break;
          }
          throw new Error('Transaction is null. Please try again!');
        case 10:
          txChainId = parseInt(evmTransaction.blockChain.chainId || '-1');
          _context2.next = 13;
          return signer.getChainId();
        case 13:
          signerChainId = _context2.sent;
          if (!(signerChainId !== txChainId)) {
            _context2.next = 16;
            break;
          }
          throw new Error("Signer chainId " + signerChainId + " doesn't match required chainId " + txChainId + ".");
        case 16:
          if (!(!!evmTransaction.approveTo && !!evmTransaction.approveData)) {
            _context2.next = 27;
            break;
          }
          approveTxData = prepareEvmTransaction(evmTransaction, true);
          _context2.next = 20;
          return signer.sendTransaction(approveTxData);
        case 20:
          approveTx = _context2.sent;
          approveTx.wait();
          _context2.next = 24;
          return checkApprovalSync(requestId, approveTx.hash, client);
        case 24:
          isApproved = _context2.sent;
          if (isApproved) {
            _context2.next = 27;
            break;
          }
          throw new Error('Error in approve transaction.');
        case 27:
          _context2.next = 29;
          return signer.getChainId();
        case 29:
          signerChainId = _context2.sent;
          if (!(signerChainId !== txChainId)) {
            _context2.next = 32;
            break;
          }
          throw new Error("Signer chainId " + signerChainId + " doesn't match required chainId " + txChainId + ".");
        case 32:
          mainTxData = prepareEvmTransaction(evmTransaction, false);
          _context2.next = 35;
          return signer.sendTransaction(mainTxData);
        case 35:
          mainTx = _context2.sent;
          mainTx.wait();
          _context2.next = 39;
          return checkTransactionStatusSync(requestId, mainTx.hash, client);
        case 39:
          status = _context2.sent;
          if (!(status.status !== TransactionStatus.SUCCESS)) {
            _context2.next = 42;
            break;
          }
          throw new Error("Cross-chain swap failed. " + (status.error || ''));
        case 42:
          return _context2.abrupt("return", status);
        case 43:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function executeEvmRoute(_x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var prettifyError = function prettifyError(error) {
  if (!error) return error;
  if (error.code && (error.code === 'ACTION_REJECTED' || error.code === 4001)) return new Error('Transaction Rejected');
  if (error && typeof error.code === 'number') {
    if (Object.values(MetamaskErrorCodes.provider).includes(error.code)) {
      return new Error(getMessageFromCode(error.code));
    }
    if (Object.values(MetamaskErrorCodes.rpc).includes(error.code)) {
      var _error$message, _error$message2, _error$message3;
      if (error.code === MetamaskErrorCodes.rpc.internal && (_error$message = error.message) != null && _error$message.includes('underpriced')) return new Error('Transaction underpriced');
      if ((_error$message2 = error.message) != null && _error$message2.includes('intrinsic gas too low') || (_error$message3 = error.message) != null && _error$message3.includes('out of gas')) return new Error('This Gas limit is low.');
      return new Error(getMessageFromCode(error.code));
    }
  }
  if (error.message) return new Error(error.message);
  return error;
};

var RangoClient = /*#__PURE__*/function () {
  function RangoClient(apiKey, debug, apiUrl) {
    if (debug === void 0) {
      debug = false;
    }
    this.apiUrl = apiUrl || 'https://api.rango.exchange';
    this.apiKey = apiKey;
    try {
      if (typeof window !== 'undefined') {
        var deviceId = localStorage.getItem('deviceId');
        if (deviceId) {
          this.deviceId = deviceId;
        } else {
          var generatedId = uuid();
          localStorage.setItem('deviceId', generatedId);
          this.deviceId = generatedId;
        }
      } else {
        this.deviceId = uuid();
      }
    } catch (e) {
      this.deviceId = uuid();
    }
    this.httpService = axios.create({
      baseURL: this.apiUrl
    });
    if (debug) {
      this.httpService.interceptors.request.use(function (request) {
        console.log('Starting Request', JSON.stringify(request, null, 2));
        return request;
      });
      this.httpService.interceptors.response.use(function (response) {
        console.log('Response:', JSON.stringify(response, null, 2));
        return response;
      });
    }
  }
  var _proto = RangoClient.prototype;
  _proto.meta = /*#__PURE__*/function () {
    var _meta = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(metaRequest, options) {
      var _metaRequest$blockcha, _metaRequest$swappers, _metaRequest$swappers2, _metaRequest$transact;
      var params, axiosResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _extends({}, metaRequest, {
              blockchains: metaRequest == null || (_metaRequest$blockcha = metaRequest.blockchains) == null ? void 0 : _metaRequest$blockcha.join(),
              swappers: metaRequest == null || (_metaRequest$swappers = metaRequest.swappers) == null ? void 0 : _metaRequest$swappers.join(),
              swappersGroups: metaRequest == null || (_metaRequest$swappers2 = metaRequest.swappersGroups) == null ? void 0 : _metaRequest$swappers2.join(),
              transactionTypes: metaRequest == null || (_metaRequest$transact = metaRequest.transactionTypes) == null ? void 0 : _metaRequest$transact.join()
            });
            _context.next = 3;
            return this.httpService.get("/basic/meta?apiKey=" + this.apiKey, _extends({
              params: params
            }, options));
          case 3:
            axiosResponse = _context.sent;
            return _context.abrupt("return", axiosResponse.data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function meta(_x, _x2) {
      return _meta.apply(this, arguments);
    }
    return meta;
  }();
  _proto.chains = /*#__PURE__*/function () {
    var _chains = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
      var axiosResponse;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.httpService.get("/basic/meta/blockchains?apiKey=" + this.apiKey, _extends({}, options));
          case 2:
            axiosResponse = _context2.sent;
            return _context2.abrupt("return", axiosResponse.data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function chains(_x3) {
      return _chains.apply(this, arguments);
    }
    return chains;
  }();
  _proto.swappers = /*#__PURE__*/function () {
    var _swappers = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
      var axiosResponse;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.httpService.get("/basic/meta/swappers?apiKey=" + this.apiKey, _extends({}, options));
          case 2:
            axiosResponse = _context3.sent;
            return _context3.abrupt("return", axiosResponse.data);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function swappers(_x4) {
      return _swappers.apply(this, arguments);
    }
    return swappers;
  }();
  _proto.messagingProtocols = /*#__PURE__*/function () {
    var _messagingProtocols = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
      var axiosResponse;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.httpService.get("/basic/meta/messaging-protocols?apiKey=" + this.apiKey, _extends({}, options));
          case 2:
            axiosResponse = _context4.sent;
            return _context4.abrupt("return", axiosResponse.data);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function messagingProtocols(_x5) {
      return _messagingProtocols.apply(this, arguments);
    }
    return messagingProtocols;
  }();
  _proto.quote = /*#__PURE__*/function () {
    var _quote = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(quoteRequest, options) {
      var body, axiosResponse;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            body = _extends({}, quoteRequest, {
              from: assetToString(quoteRequest.from),
              to: assetToString(quoteRequest.to),
              swappers: !!quoteRequest.swappers && quoteRequest.swappers.length > 0 ? quoteRequest.swappers.join(',') : undefined,
              swapperGroups: !!quoteRequest.swapperGroups && quoteRequest.swapperGroups.length > 0 ? quoteRequest.swapperGroups.join(',') : undefined,
              messagingProtocols: !!quoteRequest.messagingProtocols && quoteRequest.messagingProtocols.length > 0 ? quoteRequest.messagingProtocols.join(',') : undefined
            });
            _context5.next = 3;
            return this.httpService.get("/basic/quote?apiKey=" + this.apiKey, _extends({
              params: body,
              headers: {
                'X-Rango-Id': this.deviceId
              }
            }, options));
          case 3:
            axiosResponse = _context5.sent;
            return _context5.abrupt("return", axiosResponse.data);
          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function quote(_x6, _x7) {
      return _quote.apply(this, arguments);
    }
    return quote;
  }();
  _proto.isApproved = /*#__PURE__*/function () {
    var _isApproved = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(requestId, txId, options) {
      var axiosResponse;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return this.httpService.get("/basic/is-approved?apiKey=" + this.apiKey, _extends({
              params: {
                requestId: requestId,
                txId: txId
              },
              headers: {
                'X-Rango-Id': this.deviceId
              }
            }, options));
          case 2:
            axiosResponse = _context6.sent;
            return _context6.abrupt("return", axiosResponse.data);
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function isApproved(_x8, _x9, _x10) {
      return _isApproved.apply(this, arguments);
    }
    return isApproved;
  }();
  _proto.status = /*#__PURE__*/function () {
    var _status = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(statusRequest, options) {
      var axiosResponse;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return this.httpService.get("/basic/status?apiKey=" + this.apiKey, _extends({
              params: statusRequest,
              headers: {
                'X-Rango-Id': this.deviceId
              }
            }, options));
          case 2:
            axiosResponse = _context7.sent;
            return _context7.abrupt("return", axiosResponse.data);
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    function status(_x11, _x12) {
      return _status.apply(this, arguments);
    }
    return status;
  }();
  _proto.swap = /*#__PURE__*/function () {
    var _swap = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(swapRequest, options) {
      var body, axiosResponse;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            body = _extends({}, swapRequest, {
              from: assetToString(swapRequest.from),
              to: assetToString(swapRequest.to),
              referrerAddress: swapRequest.referrerAddress || null,
              referrerFee: swapRequest.referrerFee || null,
              disableEstimate: swapRequest.disableEstimate || false,
              swappers: !!swapRequest.swappers && swapRequest.swappers.length > 0 ? swapRequest.swappers.join(',') : undefined,
              swapperGroups: !!swapRequest.swapperGroups && swapRequest.swapperGroups.length > 0 ? swapRequest.swapperGroups.join(',') : undefined,
              messagingProtocols: !!swapRequest.messagingProtocols && swapRequest.messagingProtocols.length > 0 ? swapRequest.messagingProtocols.join(',') : undefined
            });
            _context8.next = 3;
            return this.httpService.get("/basic/swap?apiKey=" + this.apiKey, _extends({
              params: body,
              headers: {
                'X-Rango-Id': this.deviceId
              }
            }, options));
          case 3:
            axiosResponse = _context8.sent;
            return _context8.abrupt("return", axiosResponse.data);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this);
    }));
    function swap(_x13, _x14) {
      return _swap.apply(this, arguments);
    }
    return swap;
  }();
  _proto.reportFailure = /*#__PURE__*/function () {
    var _reportFailure = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(requestBody, options) {
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return this.httpService.post("/basic/report-tx?apiKey=" + this.apiKey, requestBody, _extends({
              headers: {
                'X-Rango-Id': this.deviceId
              }
            }, options));
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this);
    }));
    function reportFailure(_x15, _x16) {
      return _reportFailure.apply(this, arguments);
    }
    return reportFailure;
  }();
  _proto.balance = /*#__PURE__*/function () {
    var _balance = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(walletAddress, options) {
      var axiosResponse;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return this.httpService.get("/basic/balance?apiKey=" + this.apiKey, _extends({
              params: walletAddress,
              headers: {
                'X-Rango-Id': this.deviceId
              }
            }, options));
          case 2:
            axiosResponse = _context10.sent;
            return _context10.abrupt("return", axiosResponse.data);
          case 4:
          case "end":
            return _context10.stop();
        }
      }, _callee10, this);
    }));
    function balance(_x17, _x18) {
      return _balance.apply(this, arguments);
    }
    return balance;
  }();
  _proto.executeEvmRoute = /*#__PURE__*/function () {
    var _executeEvmRoute2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signer, route) {
      var prettifiedError, message;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return executeEvmRoute(this, signer, route);
          case 3:
            return _context11.abrupt("return", _context11.sent);
          case 6:
            _context11.prev = 6;
            _context11.t0 = _context11["catch"](0);
            prettifiedError = prettifyError(_context11.t0);
            try {
              message = (prettifiedError == null ? void 0 : prettifiedError.message) || 'Error executing the route';
              this.reportFailure({
                requestId: route.requestId,
                eventType: 'TX_FAIL',
                reason: message
              });
            } catch (err) {
              console.log({
                err: err
              });
            }
            throw prettifiedError;
          case 11:
          case "end":
            return _context11.stop();
        }
      }, _callee11, this, [[0, 6]]);
    }));
    function executeEvmRoute$1(_x19, _x20) {
      return _executeEvmRoute2.apply(this, arguments);
    }
    return executeEvmRoute$1;
  }();
  return RangoClient;
}();

export { GenericTransactionType, MetamaskErrorCodes, RangoClient, RoutingResultType, TransactionStatus, TransactionType, assetToString, cosmosBlockchains, evmBlockchains, isCosmosBlockchain, isCosmosTransaction, isEvmBlockchain, isEvmTransaction, isSolanaBlockchain, isSolanaTransaction, isStarknetBlockchain, isTonBlockchain, isTransferBlockchain, isTransferTransaction, isTronBlockchain, solanaBlockchain, starknetBlockchain, tonBlockchain, transferBlockchains, tronBlockchain };
//# sourceMappingURL=rango-sdk-basic.esm.js.map
